<template>
  <div>
    <card-list
      title="Payment Method"
      dataUrl="/api/v1/payment-method"
      dataSize="10"
      :dataHeaders="tHeaders"
      editRoute="/master/payment-method/add"
      deleteEndpoint="/api/v1/payment-method"
    />
  </div>
</template>
<script>
import CardList from "../../components/CardList";
export default {
  components: {
    CardList,
  },
  data() {
    return {
      tHeaders: [
        { id: "ID", align: "center" },
        { type_id: "Type", align: "left" },
        { label: "Label", align: "left" },
        { reference_id: "Reference", align: "left" },
        { reference_type: "Reference Type", align: "left" },
      ],
    };
  },
};
</script>
